<template>
  <div class="personal">
    <div
      class="personal-top"
    >
      <div class="personal-top-avatar" @click="personalCenterJump">
        <img class="keep-hue" :src="avatarImg" />
      </div>
      <div class="personal-top-info">
        <span class="personal-top-info-name oneRowEllipsis" @click="personalCenterJump">{{personalData.userName || '-'}}</span>
        <p class="personal-top-info-job" @click="goToJobManageCneter">
          <span class="department">{{organizationName || '-'}}</span>
          <span><img class="keep-hue" :src="require('@/assets/Home/Index/department.png')" /></span>
        </p>
      </div>
      <div class="personal-top-right" @click="personalCenterJump">
        <img :src="require('@/assets/Home/Index/personal-text.png')" />
      </div>

    </div>
    <div class="personal-bottom">
      <div
        class="personal-bottom-box"
        @click="eventJump"
      >
        <div class="event-icon">
          <svg-icon icon="todo-index"></svg-icon>
          <span class="event-icon-tip keep-hue" v-if="eventData.todo_count && eventData.todo_count.toString() !== '0'">{{eventData.todo_count || 0}}</span>
        </div>
        <div class="event-title">
          我的待办
        </div>
        <div class="data-mark">
          <p><span class="data-mark-name">催办: </span><span class="data-mark-number"><span>{{eventData.todo_urgent || 0}}</span> 项</span></p>

        </div>
      </div>
      <div
        class="personal-bottom-box"
        @click="messageJump"
      >
        <div class="event-icon">
          <svg-icon icon="message-index"></svg-icon>
          <span class="event-icon-tip keep-hue" v-if="unReadedMessageCount.toString() !== '0'">{{ unReadedMessageCount || 0 }}</span>
        </div>
        <div class="event-title">
          我的消息
        </div>
        <div class="data-mark">
          <p>
            <span class="data-mark-name">重要: </span><span class="data-mark-number"><span>{{ importantMessageCount || 0 }}</span> 条</span>
          </p>
        </div>
      </div>
      <div class="personal-bottom-box" v-loading="mailLoading" element-loading-spinner="el-icon-loading"  element-loading-background="rgba(0, 0, 0, 0)">
        <template  v-if="!mailLoading">
          <div
            class="event-icon"
            @click="mailJump(mainMail)"

          >
            <svg-icon icon="mail-index"></svg-icon>
            <span class="event-icon-tip keep-hue" v-if="mainMail.mailboxUnreadCount && mainMail.mailboxUnreadCount.toString() !== '0'">{{mainMail.mailboxUnreadCount || 0}}</span>
          </div>
          <div class="event-title">
            我的邮件
          </div>
          <div class="data-mark" >
            <div class="button" @click="goToInfo('reg')" v-if="mailBoxObj.isRegflag === 'false' && !mailLoading ">
              去注册
            </div>
            <div class="button" @click="goToInfo('bind')" v-if="mailBoxObj.isRegflag === 'true' && mailBoxObj.isBindflag === 'false' && !mailLoading">
              去绑定
            </div>
            <template v-if="mailBoxObj.isRegflag === 'true' && mailBoxObj.isBindflag === 'true' &&  mailBox">
              <p
                v-for="(item, index) in mailBox"
                :key="index"
                @click="mailJump(item)"
                class="myMail"
              >
                <el-tooltip   effect="dark" :content="item.mailboxName" placement="top" :disabled="item.mailboxName.length <= 2">
                  <span class="data-mark-name oneRowEllipsis">{{item.mailboxName}}:</span>
                </el-tooltip>
                <span class="data-mark-number oneRowEllipsis">{{item.mailboxUnreadCount || 0}}</span>
              </p>
            </template>

          </div>

        </template>

      </div>

    </div>
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import { getUserAvatar, getMailbox,getPersonalInfo } from "@/api/user.js";
import { getEventCount } from "@/api/events";
import { getUnreadedMessageList,getListMessageRecordCount} from "@/api/message";
import configR from '@/configs.js';
export default {
  name: "PersonalData",
  data() {
    return {
      // 头像
      avatarImg: "",
      // 事务统计数据
      eventData: {},
      // 消息统计消息
      messageData: {},
      mailBox: [],
      MainEmailUnreadNum: 0,
      mainMail: {},
      mailLoading: false,
      mailBoxObj: {},
      importantMessageCount:'',
      organizationName:''
    };
  },
  computed: {
    ...mapGetters([
      "userInfo",
      "request",
      "token",
      "flowServeUrl",
      "messageUrl",
      "unReadedMessageCount"
    ]),
    personalData() {
      return (this.userInfo.accounts && this.userInfo.accounts[0]) || {};
    },
  },
  created() {
    this.getUserAvatar();
    this.$bus.on("change-portrait", async () => {
      this.getUserAvatar();
    });
    this.handEventCount();
    this.handMessageRecord(0);
    this.getMailbox();
    this.getListMessageRecordCount();
    this.getPersonalInfo();
  },
  methods: {
    goToInfo(status){
      // 未注册跳转地址
      if(status === 'reg') {
        this.$router.push({name:"MailRegistry"})
      }
      // 未绑定跳转地址
      if(status === 'bind') {
        this.$router.push({name:"Information"})
      }

    },
    async getUserAvatar() {
      let param = {
        request: this.request,
        params: {
          token: this.token,
        },
      };
      let res = await getUserAvatar(param);
      if (res.byteLength === 0) return;

      try {
        this.avatarImg =
          "data:image/png;base64," +
          btoa(
            new Uint8Array(res).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
      } catch (error) {
        this.avatarImg = window.URL
          ? window.URL.createObjectURL(res)
          : window.webkitURL.createObjectURL(res);
      }
    },
    async handEventCount() {
      let data = {
        request: this.request,
        serveUrl: this.flowServeUrl,
        header: "task",
      };
      let res = await getEventCount(data);
      if (res.code !== 200) {
        this.$message.error("请求待办错误!");
        return;
      }
      this.eventData = res.data && res.data[0] || {};
    },
    handMessageRecord(star) {
      // star 1 今天； 0 全部
      let noReadData = {
        request: this.request,
        serveUrl: this.messageUrl,
        header: "message",
        params: {
          pageSize: 20,
          readed: false,
          star: star,
          readerStatus: 0,
          pageIndex: 0,
        },
      };
      getUnreadedMessageList(noReadData).then((res) => {
        if (star) {
          this.messageData.unReadedStarCount = res.data.unReadedCount;
        } else {
          this.messageData.unReadedCount = res.data && res.data.unReadedCount || '';
        }
      });
    },
    getListMessageRecordCount(){
      let param = {
        important:true
      };
      getListMessageRecordCount(param).then((res) => {
        console.log('res', res);
        if(res.code === 0) {
          this.importantMessageCount = res.data || 0;
        }
      });
    },
    async getMailbox() {
      this.mailLoading = true;
      let res = await getMailbox();
      if (res.code !== 0) {
        this.$message.error("请求邮箱信息错误!");
        this.mailLoading = false;
        return;
      }
      this.mailLoading = false;
      this.mailBoxObj = res.data || {};
      this.mailBox = res.data.mailboxList || [];
      let mainMail = this.mailBox.filter((item) => item.mainEmail === true);
      this.mainMail = (mainMail && mainMail[0]) || {};
    },
    getPersonalInfo(){
      getPersonalInfo().then(res=>{
        console.log('res', res)
        if(res.code === 0) {
          this.organizationName = res.data.attributes && res.data.attributes.organizationName
        }
      })
    },
    personalCenterJump() {
      if(configR.envConfigs.PERSONAL_CENTER_LINK) {
        window.open(configR.envConfigs.PERSONAL_CENTER_LINK);
      } else {
        const { href } = this.$router.resolve({
          name: "PersonalCenter",
        });
        window.open(href);
      }
    },
    mailJump(item) {
      if (!item.mailboxUnreadUrl) {
        this.$message.error("无跳转链接！");
        return;
      }
      window.open(item.mailboxUnreadUrl);
    },
    messageJump() {
      this.$router.push({ name: "MyMessage" });
    },
    eventJump() {
      this.$router.push({ name: "EventsCenter", params: { tabNum: 0 } });
    },
    goToJobManageCneter(){
      this.$router.push({ name: "BusinessManagementCenter", params: { activeTab: 'PostManagement'} });
    }
  },
};
</script>

<style scoped lang="scss">
  @import "@/styles/variables.scss";
.personal {
  width: 100%;
  &-top {
    padding: 20px 0 20px 20px;
    display: flex;
    align-items: center;
    background: url("../../../assets/Home/Index/personal-data-bg.png") no-repeat;
    background-size: cover;
    position: relative;
    cursor: pointer;
    &-avatar {
      width: 57px;
      height: 57px;
      overflow: hidden;
      margin-right: 17px;
      border-radius: 50%;
      background-color: #c0c4cc;
      img {
        object-fit:cover;
        width: 100%;
        min-height: 100%;
        border-radius: 50%;
      }
    }
    &-info {
      flex: 1;
      &-name {
        font-size: 24px;
        color: white;
        line-height: 24px;
        font-weight: 400;
        display: inline-block;
        max-width: calc(100% - 79px);
      }
      &-job {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: white;
        line-height: 14px;
        font-weight: 400;
        img {
          width: 26px;
          height: 26px;
          margin-left: 5px;
        }
      }
    }
    &-right {
      width: 79px;
      height: 30px;
      img {
        width: 100%;
        height: 100%;
      }
      position: absolute;
      right: 0;
      top: 15px;
    }
  }
  &-bottom {
    width: 100%;
    padding-top: 53px;
    padding-bottom: 54px;
    height: 239px;
    background: url("../../../assets/Home/Index/personal-bottom-bg.png")
      no-repeat;
    background-size: cover;
    display: flex;
    &-box {
      width: 33.3%;
      border-right: 1px solid #e6e6e6;
      cursor: pointer;
      &:nth-child(3) {
        border-right: 0;
      }
      .event-icon {
        width: 50px;
        height: 50px;
        text-align: center;
        margin: 0 auto 17px;
        position: relative;
        svg {
          width: 50px;
          height: 50px;
        }
        &-tip {
          display: inline-block;
          border-radius: 10px;
          background: #ff0904;
          padding: 0 9px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          color: #fff;
          font-size: 14px;
          position: absolute;
          top: -9px;
          right: -12px;
        }
      }
      .event-title {
        text-align: center;
        height: 16px;
        font-size: 15px;
        font-weight: bold;
        color: #434343;
        line-height: 16px;
        margin-bottom: 10px;
      }
      .data-mark {
        display: flex;
        flex-direction: column;
        align-items: center;
        .button {
          width: 60px;
          height: 24px;
          line-height: 24px;
          border: 1px solid $color-primary;
          color:$color-primary;
          font-size: 12px;
          border-radius: 25px;
          text-align: center;
          margin:0 auto;
          cursor: pointer;
        }
        p {
          line-height: 18px;
          font-size: 13px;
          font-weight: 400;
          color: #888888;
          display: flex;
          justify-content: center;
          /*span.data-mark-name {*/
          /*  width: 40px;*/
          /*  text-align: right;*/
          /*}*/
          span.data-mark-number {
            text-align: left;
            color: #434343;
            padding-left:12px;
            > span {
              display: inline-block;
            }
          }
          span.data-mark-light {
            color: #00479d;
          }
        }
      }
    }
  }
  .myMail {
    width: 58px;
    .data-mark-name {
      width: 30px;
    }
    .data-mark-number {
      width: 28px;
      text-align: left;
    }
  }
}
</style>